var _rect, _rect2, _rect3, _rect4, _rect5, _polygon, _text, _text2, _text3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "25 10 275 70",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hexGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#4ECDC4",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#45B7B8",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#2E86AB",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "accentGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#4ECDC4",
      stopOpacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#26D0CE",
      stopOpacity: 0.6
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 15,
    width: 8,
    height: 8,
    fill: "#4ECDC4",
    opacity: 0.7
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 15,
    width: 6,
    height: 6,
    fill: "#26D0CE",
    opacity: 0.8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 113,
    y: 18,
    width: 4,
    height: 4,
    fill: "#4ECDC4",
    opacity: 0.6
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 25,
    width: 6,
    height: 6,
    fill: "#26D0CE",
    opacity: 0.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 27,
    width: 8,
    height: 8,
    fill: "#4ECDC4",
    opacity: 0.7
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "55,15 95,15 115,45 95,75 55,75 35,45",
    fill: "url(#hexGradient)",
    stroke: "none"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 75,
    y: 58,
    fontFamily: "Arial, sans-serif",
    fontSize: 32,
    fontWeight: "bold",
    textAnchor: "middle",
    fill: "white"
  }, "NT")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 42,
    fontFamily: "Arial, sans-serif",
    fontSize: 20,
    fontWeight: "bold",
    fill: "#2E86AB"
  }, "NUMANTRA")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 65,
    fontFamily: "Arial, sans-serif",
    fontSize: 20,
    fontWeight: "bold",
    fill: "#4ECDC4"
  }, "TECHNOLOGIES")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo-dark.94e75a490f6d7099b34b248d37e99487.svg";
export { ForwardRef as ReactComponent };